import { render, staticRenderFns } from "./MclaseForm.vue?vue&type=template&id=5ca64fe3"
import script from "./MclaseForm.vue?vue&type=script&lang=js"
export * from "./MclaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports